import { inject, Injectable } from "@angular/core";
import { DatePickerSelection } from "@net3-multiplatform-client/libs";
import { differenceInDays, subDays } from "date-fns";
import { ENVIRONMENT, Environment } from "libs/core/auth/auth.tokens";
import { SectorHistoryTableRow } from "libs/features/sectors/models/sector.interfaces";

@Injectable({ providedIn: 'root' })
export class HistoryServiceUi {

  private options: Environment = inject(ENVIRONMENT);
  

  constructor() {
  }

  // Retorna el màxim de dies permesos segons l'agrupació
  getMaxDays(agroupationValue: number): number {
    switch (agroupationValue) {
      case 0: return 7;
      case 1: return 31;
      case 2: return 92;
      default: return 7;
    }
  }

  // Comprova si el rang de dates és vàlid segons el límit d'agrupació
  isValidRange(selection: DatePickerSelection, agroupationValue: number): boolean {
    const days = differenceInDays(selection.endDate!, selection.startDate!);
    return days < (this.getMaxDays(agroupationValue));
  }

  // Ajusta automàticament el rang de dates si supera el màxim permès
  onErrorResponse(selection: DatePickerSelection, agroupationValue: number): DatePickerSelection {
    const maxDays = this.getMaxDays(agroupationValue);
    const days = differenceInDays(selection.endDate!, selection.startDate!);

    if (days >= maxDays) {
      return {
        startDate: subDays(selection.endDate!, maxDays - 1),
        endDate: selection.endDate,
        type: selection.type
      };
    }

    return selection;
  }

  //Processa les dades d'historial afegint flags d'inici de dia o hora segons l'agrupació
  processResponse(data: SectorHistoryTableRow[],agroupationValue: number): SectorHistoryTableRow[] {

    switch (agroupationValue) {
      case 0: //Hora
        return this.prepareData(data, true, true);
      case 1: //Dia
        return this.prepareData(data, true, false);
      case 2: //Total
        return this.prepareData(data, false, false);
      default:
        return data;
    }
  }

  //Prepara les dades afegint flags d'inici de dia i hora
  private prepareData(data: SectorHistoryTableRow[],days = true,hours = true): SectorHistoryTableRow[] {

    return data.map((row, i, arr) => {

      const currentFrom = this.parseDate(row.from);
      const prev = i > 0 ? arr[i - 1] : null;
      const prevFrom = prev ? this.parseDate(prev.from) : null;

      const isNewDay =
        i === 0 ||
        !prevFrom ||
        currentFrom.toDateString() !== prevFrom.toDateString();

      const isNewHourRange =
        isNewDay || !prev || currentFrom.getHours() !== prevFrom.getHours();

      return {
        ...row,
        ...(days && { isNewDay }),
        ...(hours && { isNewHourRange })
      };
    });
  }

  //Converteix un string ISO de data i hora a objecte Date
  private parseDate(dateStr: string): Date {
    const [date, time] = dateStr.split('T');
    const [day, month, year] = date.split('-').map(Number);
    const [hours, minutes] = time.substring(0, time.length - 1).split(':').map(Number);

    return new Date(year, month - 1, day, hours, minutes);
  }

}